import React, { useState } from 'react'

import { CardActionArea } from 'components/Card'
import Icon from 'components/Icon'
import Lightbox from 'components/Lightbox'
import { FixedImage } from 'components/NextImage'
import { useEventContext } from 'context/EventContext'

import classes from './Media.module.scss'

const Media = ({ listing }) => {
  const [lightboxState, setLightboxState] = useState({ toggler: false })
  const eventContext = useEventContext()
  const media = listing.screenshots.concat(listing.videos || [])
  const main = media[0]
  const isVideo = item => !!item?.thumbnail
  const captions = listing.screenshots.map(screenshot => screenshot.caption)

  const handleOnClose = () => {
    eventContext.sendEvent({
      engagementComponent: 'product_media',
      engagementDestination: 'close-media',
      engagementDetails: 'media',
      name: 'engagement_product_click',
    })
  }

  const lightboxToggleHandler = () => {
    eventContext.sendEvent({
      engagementComponent: 'product_media',
      engagementDestination: 'open-media',
      engagementDetails: 'media',
      name: 'engagement_product_click',
    })

    setLightboxState({
      toggler: !lightboxState.toggler,
    })
  }

  return (
    <>
      {media && media.length > 0 ? (
        <>
          <CardActionArea
            className={classes.cardActionArea}
            role="link"
            tabIndex="0"
            onClick={lightboxToggleHandler}
            onKeyPress={lightboxToggleHandler}
          >
            <FixedImage
              className={classes.image}
              title={listing.name}
              alt={listing.name}
              src={isVideo(main) ? main.thumbnail : main.url}
              fetchWidth={850}
            />
            <div className={classes.caption}>{media.length > 1 ? `View ${media.length - 1} more` : 'View media'}</div>
          </CardActionArea>
          <Lightbox
            onClose={handleOnClose}
            sources={media.map(x => x.embed_url || x.url)}
            toggler={lightboxState.toggler}
            captions={captions}
          />
        </>
      ) : (
        <div className={classes.noMedia}>
          <Icon icon={['far', 'images']} className={classes.imagesIcon} />
          <div className={classes.noMediaText}>No media yet</div>
        </div>
      )}
    </>
  )
}

export default Media
